import * as types from '../mutation-types'
import { getLoginData, getMenuData, doLogout } from "@/api/login"
import { MENU, TOKEN, ENTITY } from "@/common/const"
import { menuFormat } from "@/utils"
import jwtDecode from 'jwt-decode'

const state = {
  authorization: localStorage.getItem(TOKEN) ? localStorage.getItem(TOKEN) : '',
  menu: localStorage.getItem(MENU) ? JSON.parse(localStorage.getItem(MENU)) : '',
  entity: localStorage.getItem(ENTITY) ? JSON.parse(localStorage.getItem(ENTITY)) : ''
}

const getters = {
  userName: (state) => {                   // 登录的用户名
    let username = ''
    try {
      username = jwtDecode(state.authorization).username
    } catch (error) {
      console.log(error.message)
    } finally {
      return username
    }
  },
  entityId: (state) => {                   // 登录用户所属运营单位
    let entityId = ''
    try {
      entityId = jwtDecode(state.authorization).entityId
    } catch (error) {
      console.log(error.message)
    } finally {
      return entityId
    }
  },
  roleId: (state) => {                     // 登录用户的角色id
    let roleId = ''
    try {
      roleId = jwtDecode(state.authorization).roleId
    } catch (error) {
      console.log(error.message)
    } finally {
      return roleId
    }
  },
  entityId2name: (state, getters) => (id) => {
    return state.entity[id]
  }
}
const mutations = {
  // 修改token
  [types.UPDATE_TOKEN]: (state, authorization) => {
    state.authorization = authorization
  },
  // 修改menu
  [types.UPDATE_MENU]: (state, menu) => {
    state.menu = menu
  },
  // 修改entity
  [types.UPDATE_ENTITY]: (state, entity) => {
    state.entity = entity
  }
}

const actions = {
  /**
   * 异步登录操作
   * @param {*} context
   * @param {*} userInfo
   */
  login(context, userInfo) {
    const {username, password, code} = userInfo
    return new Promise((resolve, reject) => {
      getLoginData(username, password, code).then(res => {
        // 登录成功，更新token
        // console.log(res)
        context.commit(types.UPDATE_TOKEN, res.authorization)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 异步请求菜单操作
   * @param {*} context
   */
   getMenu(context) {
    return new Promise((resolve, reject) => {
      getMenuData(context.getters.roleId).then(res => {
        // 获取菜单成功，更新menu
        console.log("-------------------",res.menu)
        const menu = menuFormat(res.menu.children)

        localStorage.setItem(MENU, JSON.stringify(menu))
        context.commit(types.UPDATE_MENU, menu)
        resolve(res.menu.children)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 异步请求运营单位操作
   * @param {*} context
   */
/*  getEntity(context) {
    return new Promise((resolve, reject) => {
      getEntityData(context.getters.entityId).then(res => {
        // 获取运营单位成功，更新entity
        console.log(res)
        const entity = res.data[0]
        localStorage.setItem(ENTITY, JSON.stringify(entity))
        context.commit(types.UPDATE_ENTITY, entity)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }, */
  logout(context) {
    return new Promise((resolve, reject) => {
      doLogout().then(res => {
        // 注销成功
        localStorage.removeItem(TOKEN)
        context.commit(types.UPDATE_TOKEN, '')
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
